import { Col } from "react-bootstrap"

export const ProjectCard = ({ title, description, imgUrl, direction }) => {
    
    return(
        <Col sm={6} md={4}>
        <div className="proj-imgbx">
            <img src={imgUrl} alt="pImg" />
            <div className="proj-txtx">
                <h4>{title}</h4>
                <span>{description}</span>
                <br />
                <a href={direction}>Lets see more</a>
            </div>
        </div>
        </Col>
    )
}